import { ReactNode } from 'react';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import AccountingMonthFilter from './AccountingMonthFilter';
import StatusFilter from './StatusFilter';
import JournalTypeFilter from './JournalTypeFilter';
import { AppPermissions } from '../../../types';
import { PermissionsProvider } from '../../Permissions';
import { DivisionCountryFilter } from '../../filters';
import { FilterPanel, StatusChip } from '../../Visual';
import {
  accountingEntriesChangeFilterCountry,
  accountingEntriesFilterCountrySelector,
} from '../../../state';

export interface AccountingEntriesFiltersProps {
  actions: ReactNode;
  applyDisabled: boolean;
  countryRequiredIncomplete: boolean;
  accountingMonthRequiredIncomplete: boolean;
}

const AccountingEntriesFilters = ({
  actions,
  applyDisabled,
  countryRequiredIncomplete,
  accountingMonthRequiredIncomplete,
}: AccountingEntriesFiltersProps) => {
  const { t } = useTranslation();

  return (
    <PermissionsProvider
      resourcePermissions={[
        AppPermissions.ACCOUNTING_ENTRIES_COMPLETE,
        AppPermissions.ACCOUNTING_ENTRIES_QUERY,
      ]}
    >
      <FilterPanel
        subtitleTranslationKey="accountingEntries.filters.subtitle"
        actions={
          <StatusChip
            status={applyDisabled ? 'warning' : 'success'}
            label={applyDisabled ? t('filters.status.missingRequired') : t('filters.status.ready')}
          />
        }
      >
        <Grid container spacing={3} alignItems="flex-end">
          <Grid item xs={12} md={4} lg={2} xl={2}>
            <DivisionCountryFilter
              valueSelector={accountingEntriesFilterCountrySelector}
              actionChange={accountingEntriesChangeFilterCountry}
              fullWidth
              requiredIncomplete={countryRequiredIncomplete}
            />
          </Grid>
          <Grid item xs={12} md={4} lg={2} xl={2}>
            <AccountingMonthFilter requiredIncomplete={accountingMonthRequiredIncomplete} />
          </Grid>
          <Grid item xs={12} md={4} lg={2} xl={2}>
            <JournalTypeFilter fullWidth />
          </Grid>
          <Grid item xs={12} md={4} lg={2} xl={2}>
            <StatusFilter fullWidth />
          </Grid>
          <Grid item xs={12} md lg xl>
            {actions}
          </Grid>
        </Grid>
      </FilterPanel>
    </PermissionsProvider>
  );
};

export default AccountingEntriesFilters;
